import React, { useState, ChangeEvent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser, faKey } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { AnyAction, Dispatch, bindActionCreators } from 'redux';
import { login } from '../../store/actions/auth';
import TextInput from '../../components/TextInput';
import { checkProperties, checkFieldValidation } from '../../services/utilService';
import { IFormState } from '../../shared/models/validations';
import update from 'react-addons-update';
import { UserRole } from '../../shared/models/adminModels';


interface ILoginState {
    username:string;
    password: string;
}
const Login = (props: any) => {
    const [credential, setCredential] = useState<ILoginState>({
        username: '',
        password: '',
    });
    const [loginForm, setLoginForm] = useState<IFormState>({
        valid: false,
        errors: {},
        validations : {
            username : {
                label:'Email',
                required: true,
                email: true
            },
            password: {
                label:'Password',
                required: true,
            }
        }
    }); 

    const handleChange = (e:ChangeEvent<HTMLInputElement>) => {
        const { name, value} = e.target;
        setCredential({...credential,[name]:value });
        const validations = loginForm.validations;
        if(Object.keys(validations).includes(name)) {
            const error = checkFieldValidation(validations[name],value);
            setLoginForm(update(loginForm,{
                errors:{
                    [name] : { $set :error}
                }
            }))
        }
    }

    const checkFormValidation = () => {
        let errors : any = {};
        type IValidation = keyof ILoginState;
        const validations = loginForm.validations;
        Object.keys(validations).forEach((field : any) => {
            const fieldName : IValidation = field
            errors[fieldName] = checkFieldValidation(validations[field],credential[fieldName]);
        });
        return errors;
    }
    const doLogin = async (e: Event) => {
        e.preventDefault();
        const errors = await checkFormValidation();
        const form = {
            ...loginForm,
            errors,
        }
        setLoginForm(form);
        const noError =  checkProperties(form.errors);
        if (noError) {
            const loginResponse = await props.doLogin(credential);
            if (loginResponse.isLoggedIn) {
                const { userType } = loginResponse;
                if(userType === Number(UserRole.Admin)) {
                    props.history.push('/admin-dashboard');
                } else {
                    props.history.push('/main-dashboard');
                }
            }
        }
    }
    // const { errors } = loginForm;
    return (
    <div className="login-center">

        <div className="login-wrapper">
            <div className="login-top">
                <img src="assets/images/logo.png" />
            </div>
            <div className="login-content">
                <form className="witt-form login-form">
                    <div className="form-group">
                        <FontAwesomeIcon icon={faUser} />
                        <TextInput  
                        placeholder="Username" 
                        value={credential.username}
                        name="username"
                        error={loginForm.errors.username}
                        onChange={handleChange}
                         />
                    </div>
                    <div className="form-group">
                        <FontAwesomeIcon icon={faKey} />
                        <TextInput  
                        type="password"
                        placeholder="Password" 
                        value={credential.password}
                        name="password"
                        error={loginForm.errors.password}
                        onChange={handleChange}
                         />
                    </div>
                    <div className="login-action text-center">
                        <button disabled={props.isLoading} type="submit" className="btn btn-primary w-100" onClick={(e: any) => doLogin(e)}>Login</button>
                        <Link  className="mt-5 forgot-pass" to="forgot-password">Forgot password?</Link>
                    </div>
                </form>
            </div>
        </div>
    </div>
   )
}

const mapStateToProps = (state: any) => ({
    isLoading: state.common.isLoading
})

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({
    doLogin:  bindActionCreators(login,dispatch)
});

        
export default connect(mapStateToProps,mapDispatchToProps)(Login);